<template>
  <div class="modal fade" tabindex="-1" ref="lineupPositionModal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t('lineupModal.changeLineupPosition') }}
            </h5>
          <button type="button" class="btn-close" @click="closeModal"></button>
        </div>
        <div class="modal-body">
          <label>{{ $t('lineupModal.select') }}:</label>
            <button
                v-for="position in filteredPositions"
                :key="position"
                class="btn m-0 p-2 my-2 w-100"
                :class="{'btn-bb5-yellow': currentPosition !== position, 'btn-bb5-black': currentPosition === position}"
                :disabled="currentPosition === position"
                @click="selectPosition(position)"
            >
              {{ $t('lineupModal.position') }} {{ position }}
            </button>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeModal">{{ $t('cancel') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
import { Modal } from 'bootstrap';


<script>
import {Modal} from "bootstrap";

export default {
  props: {
    currentPosition: {
      type: Number
    },
    maxPositions: {
      type: Number,
      default: 8 // Standardmäßig Positionen 1 bis 8
    }
  },
  data() {
    return {
      selectedPosition: null // Vom Nutzer gewählte Position
    };
  },
  computed: {
    filteredPositions() {
      // Alle Positionen außer der aktuellen
      return Array.from({ length: this.maxPositions }, (_, i) => i + 1)
    }
  },
  methods: {
    openModal() {
      const modalElement = this.$refs.lineupPositionModal;
      const modalInstance = new Modal(modalElement);
      modalInstance.show();
    },
    closeModal() {
      const modalElement = this.$refs.lineupPositionModal;
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.hide();
    },
    selectPosition(position) {
      this.$emit('positionchanged', position);
      this.closeModal();
    }
  }
};
</script>

<style scoped>
</style>